// 全局常用变量
// 业务基础类
class ContextService {
    public siteHost: string = '';
    public system: string = '';
    public lang: string = '';
}

const contextService = new ContextService();

const SYSTEM = {
    CN: 'CN',
    EN: 'EN',
    EM: 'EM',
    JP: 'JP',
    TW: 'TW',
    ATES: 'ATES',
};

const getContextService = () => {
    return contextService;
};

export { SYSTEM, contextService, getContextService };
